// angular
// 	.module("HeroPRO")
// 	.factory("CommonValidationFactory", commonValidationFactory);

/* @ngInject */
export default function commonValidationFactory() {
    return {
        validatePassword,
    };


    function validatePassword(password) {
        if (password && password.length > 0) {
            // Minimum 8 characters, must contain upper, lower, numeric, and special characters
            let message = '';

            const regExErrors = [];

            message += (password.length >= 8) ? '' : 'minimum 8 characters';
            checkForUpperCase(password, regExErrors);
            checkForLowerCase(password, regExErrors);
            checkForNumeric(password, regExErrors);
            checkForSpecialChar(password, regExErrors);

            // Construct error message
            if (regExErrors.length > 0) {
                message += (message.length > 0) ? ', must contain ' : 'must contain ';
                for (let i = 0; i < regExErrors.length; i++) {
                    message += regExErrors[i];
                    if (i + 2 < regExErrors.length) {
                        message += ', ';
                    } else if (i + 2 === regExErrors.length) {
                        message += ', and ';
                    }
                }
            }
            return message.charAt(0).toUpperCase() + message.slice(1);
        }
        return '';
    }

    function checkForUpperCase(password, regExErrors) {
        const regExUpperAlpha = /^(?=.*?[A-Z]).+$/;
        if (!regExUpperAlpha.test(password)) {
            regExErrors.push('upper');
        }
    }

    function checkForLowerCase(password, regExErrors) {
        const regExLowerAlpha = /^(?=.*?[a-z]).+$/;
        if (!regExLowerAlpha.test(password)) {
            regExErrors.push('lower');
        }
    }

    function checkForNumeric(password, regExErrors) {
        const regExNumeric = /^(?=.*?[0-9]).+$/;
        if (!regExNumeric.test(password)) {
            regExErrors.push('numeric');
        }
    }

    function checkForSpecialChar(password, regExErrors) {
        const regExSpecChar = /^(?=.*?[#?!@$%^&*-]).+$/;
        if (!regExSpecChar.test(password)) {
            regExErrors.push('special characters');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/common/dataFactories/commonValidationFactory.js